export const TYPES = {
  SELECT_ALL_INCOME_SUCCESS: "incomeByStaff/SELECT_ALL_INCOME_SUCCESS",
  SELECT_ALL_BRANCH_SUCCESS: "incomeByStaff/SELECT_ALL_BRANCH_SUCCESS",
  SELECT_USER_INFO_SUCCESS: "incomeByStaff/SELECT_USER_INFO_SUCCESS",
  SELECT_ALL_INCOME_BY_BRANCH_SUCCESS: "incomeByStaff/SELECT_ALL_INCOME_BY_BRANCH_SUCCESS",
};
